var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPhoto = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.334,
    viewBox: "0 0 20 18.334",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#999}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.208,157.182a3.12,3.12,0,0,1-2.952-2.126l-.029-.1a3.042,3.042,0,0,1-.144-.9v-5.682L.061,155.124a1.893,1.893,0,0,0,1.327,2.3l12.886,3.451a1.912,1.912,0,0,0,.48.062,1.858,1.858,0,0,0,1.8-1.363l.751-2.387Zm0,0",
    transform: "translate(0 -142.598)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M150.987,67.826a1.667,1.667,0,1,0-1.667-1.667A1.668,1.668,0,0,0,150.987,67.826Zm0,0",
    transform: "translate(-143.487 -61.992)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.9.492H87.4A2.086,2.086,0,0,0,85.32,2.576v9.167A2.086,2.086,0,0,0,87.4,13.826H99.9a2.086,2.086,0,0,0,2.083-2.083V2.576A2.086,2.086,0,0,0,99.9.492ZM87.4,2.159H99.9a.417.417,0,0,1,.417.417V8.492L97.688,5.42a1.493,1.493,0,0,0-1.118-.512,1.457,1.457,0,0,0-1.113.526l-3.1,3.715L91.354,8.142a1.463,1.463,0,0,0-2.067,0l-2.3,2.3V2.576A.417.417,0,0,1,87.4,2.159Zm0,0",
    transform: "translate(-81.987 -.492)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPhoto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_photo.2cb481c7d686d7cf21afadbc945a507d.svg";